<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
          @titleClick='onItemClick'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <MonthPlanCar v-if="selectedIndex === 0"/>
    <MonthMrp v-if="selectedIndex === 1" />
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
import MonthMrp from './MonthMrp'
import MonthPlanCar from './MonthPlanCar'

export default {
  name: 'bom-tab',
  data: function () {
    return {
      selectedIndex: 0,
      displayPurchase: 'block',
      displayProduct: 'none',
      selectedCode: 'ALL',
      tabs: []
    }
  },
  components: {
    DxTabPanel,
    MonthPlanCar,
    MonthMrp
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
    const topMenuTab = this.$store.getters.getTopMenuTabByUrl(this.$route.path)
    if (topMenuTab !== null) {
      const tabNameArray = topMenuTab.multiTabName.split('/')
      for (let i = 0; i < tabNameArray.length; i++) {
        let temp = {}
        temp.title = tabNameArray[i]
        this.tabs.push(temp)
      }
    }
    this.$snotify.info('월계획 수정/저장 후 에는 월품목소요량 탭에서 전품목 소요량 재산출 버튼을 반드시 클릭 하여주세요.')
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onItemClick (e) {
      if (this.tabs[e.itemIndex].code === 'ALL') {
        return
      }
      this.selectedCode = this.tabs[e.itemIndex].code
      // if (this.selectedCode === ConstDef.구매품 || this.selectedCode === ConstDef.완제품) {
      //   return
      // }
    }
  }
}
</script>

<style lang="scss">
  .purchaseActive {
    display: none;
  }
  .productActive {
    display: none;
  }

</style>
